module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal text-dark",
    attrs: {
      "slot": "insertComponent",
      "id": "d-create-task-for-user"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Status fra oprettelsen")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [(_vm.errorUsers.length > 0) ? _c('div', {
    staticClass: "show-response__banner show-response__banner--warning"
  }, [_c('span', {
    staticClass: "icon-warning show-response__banner__icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "show-response__banner__text"
  }, [_c('strong', [_vm._v("\n            " + _vm._s(_vm.errorUsers.length) + "\n            " + _vm._s(_vm.errorUsers.length === 1 ? 'bruger kom ikke med på listen' : 'brugere kom ikke med på listen') + "\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            " + _vm._s(_vm.errorUsers.length === 1 ? 'Denne bruger har' : 'Disse brugere har') + " opgaver med lønkode og burde\n            have fået et tillæg, men mangler en oplysning. Ret det i siden 'Årsnorm', og hent opgaver med\n            lønkoder igen.\n          ")])])]) : _c('div', {
    staticClass: "show-response__banner show-response__banner--ok"
  }, [_c('span', {
    staticClass: "icon-checkmark-circle show-response__banner__icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "show-response__banner__text"
  }, [_c('strong', [_vm._v("Alle relevante brugere kom med")]), _vm._v(" "), _c('p', [_vm._v("Der er ingen brugere med opgaver med lønkode, der mangler oplysninger.")])])]), _vm._v(" "), _c('Tabs', {
    attrs: {
      "tabs": _vm.computedTabs,
      "selected": _vm.selectedTab
    },
    on: {
      "select": function($event) {
        _vm.selectedTab = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "do-table marg-1-top"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Navn")]), _vm._v(" "), (_vm.selectedTab === 'error') ? _c('th', [_vm._v("Hvad mangler")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'error') ? _c('th', [_vm._v("Sådan løser du det")]) : _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', [(_vm.usersFiltered.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": _vm.selectedTab === 'error' ? 3 : 2
    }
  }, [_vm._v("\n            " + _vm._s(_vm.selectedTab === 'error' ? 'Ingen brugere mangler oplysninger' : 'Ingen brugere blev oprettet') + "\n          ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.usersFiltered), function(user) {
    return _c('tr', {
      key: user.user_id,
      class: {
        'show-response__row--error': user.result === 'error'
      }
    }, [_c('td', [_vm._v(_vm._s(user.user_name))]), _vm._v(" "), (_vm.selectedTab === 'error') ? [_c('td', [_c('span', {
      staticClass: "do-warning"
    }, [_vm._v(_vm._s(_vm.errorDescription(user.error)))])]), _vm._v(" "), _c('td', {
      staticClass: "show-response__hint"
    }, [_vm._v(_vm._s(_vm.errorHint(user.error)))])] : _c('td', [_c('span', {
      staticClass: "show-response__ok"
    }, [_vm._v("✔️ Oprettet")])])], 2)
  })], 2)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57e202ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supplements/ShowResponse.vue
// module id = 1935
// module chunks = 1